// Module
var code = "<div class=\"tag-typeahead-result clearfix\"> <div class=\"clearfix row\"> <div class=\"col-xs-12\" ng-click=\"context.onAdd($event, data)\"> <div>{{ data.tag }}</div> </div> </div> </div> ";
// Exports
module.exports = code;